import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=81d01f0a&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=js"
export * from "./Trades.vue?vue&type=script&lang=js"
import style0 from "./Trades.vue?vue&type=style&index=0&id=81d01f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d01f0a",
  null
  
)

export default component.exports